import { render, staticRenderFns } from "./MyMusicPage.vue?vue&type=template&id=2412b0d2"
import script from "./MyMusicPage.vue?vue&type=script&lang=js"
export * from "./MyMusicPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports